// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fL","seoBlockContent_visible":"c-a_fM"};